import common from '@/store/common/mutations';
import * as types from './mutation-types';

const getInit = () => {
	return {
		searchParams: {
			pgmId: null,
			jobGroupId: null,
			jobId: null,
			jobNm: null,
			fromDate: null,
			toDate: null,
			useYn: null				
		},
		batchHistoryList: [],	
		useYnList: [],
		pagingInfo: {
			currentPage: 1,
			endPage: 1,
			pageUnit: 10,
			startPage: 1,
			totalSize: 1
		}
	};
};

const selectDate = (state, { from, to }) => {
	// console.log('mutation-selectDate', from, to);	
	state.searchParams.fromDate = from;
	state.searchParams.toDate = to;
	// console.log('mutation-selectedDate', state.fromDate, state.toDate);
};

export default {
	...common,	
	selectDate,
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit()); //
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
